import { writable, derived } from 'svelte/store';
import { apiFetch } from '../lib/api/client.js';
import { authState } from './auth.js';

export const licenseState = writable({
  plan: 'trial',
  active: true,
  trialEndsAt: null,
  expiresAt: null,
  billingCycle: 'yearly',
  priceEUR: 12,
  features: ['scan', 'library', 'export']
});

export const isTrial = derived(licenseState, ($license) => $license.plan === 'trial');
export const isActive = derived(licenseState, ($license) => Boolean($license.active));

export function setLicense(license) {
  if (!license) return;
  licenseState.update((state) => ({ ...state, ...license }));
}

export async function fetchLicense() {
  let token = null;
  authState.subscribe((value) => {
    token = value.token;
  })();
  if (!token) return;
  const { license } = await apiFetch('/license', { token });
  setLicense(license);
}
